import React from 'react';
import { Switch } from '@mui/material';
import { approvalTableSwitchSx } from './InventoryApprovalSx';

interface ApprovalToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
}

const ApprovalToggleSwitch: React.FC<ApprovalToggleSwitchProps> = ({ checked, onChange }) => (
  <Switch
    checked={checked}
    onChange={onChange}
    sx={approvalTableSwitchSx}
    inputProps={{ 'data-testid': 'approval-toggle-switch' } as React.InputHTMLAttributes<HTMLInputElement>}
  />
);

export default ApprovalToggleSwitch;
